<template>
  <div
    class="results height-100"
    :class="`${completed && 'completed'} ${rightSwiped.length === 0 && 'bg0'}`"
  >
    <div
      class="matched-text size-24 weight6 white--text mx-auto"
      :class="rightSwiped.length === 0 && 'width-100 height-100'"
    >
      <div class="pt-x" v-if="rightSwiped.length !== 0">
        Cool...diese Autos passen zu dir
      </div>
      <template v-else>
        <div class="height-100">
          <CoverSection @onStart="$emit('tryAgain')" :hideStart="true">
            <div class="my-auto px-5">
              Kein passendes Auto gefunden - 
              hier alle unsere Modelle
            </div>
          </CoverSection>
          <AllCars />
        </div>
      </template>
    </div>
    <div style="width: 95%" class="mx-auto mt-10" v-if="completed">
      <VehicleCard
        class="mb-8"
        v-for="vehicle of likedVehicles"
        :key="vehicle.id"
        :vehicle="vehicle"
        :showActions="true"
        :showCarousel="true"
      />
    </div>
  </div>
</template>

<script>
import {VehicleCard, CoverSection, AllCars} from '@/components'

export default {
  name: 'swipe-results',
  props: ['rightSwiped', 'completed', 'likedVehicles'],
  components: {
    VehicleCard,
    CoverSection,
    AllCars
  }
}
</script>

<style lang="scss" scoped>
.results {
  display: none;
  will-change: transform;
  background: linear-gradient(33.53deg, #022239 0%, #030E30 100%);
  background-size: 100% 290px;
  background-repeat: no-repeat;
  background-attachment: fixed;

  &.completed {
    display: block;
  }
  
  &.bg0 {
    background: unset !important;
  }

  .matched-text {
    width: 334px;
    text-align: center;
  }

  .pt-x {
    padding-top: 110px;
  }
}
</style>